import _classCallCheck from "/go/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/go/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

var LjhAnalytics = /*#__PURE__*/function () {
  function LjhAnalytics() {
    _classCallCheck(this, LjhAnalytics);
  }

  _createClass(LjhAnalytics, null, [{
    key: "identify",
    value: function identify(email, traits) {
      if (!traits) {
        traits = {};
      }

      traits.email = email;
      window.analytics && window.analytics.identify(email, traits);
    }
  }, {
    key: "track",
    value: function track(name, properties) {
      if (!properties) {
        properties = {};
      }

      window.analytics && window.analytics.track(name, properties);
    }
  }, {
    key: "page",
    value: function page(name, properties) {
      if (!properties) {
        properties = {};
      }

      window.analytics && window.analytics.page(name, properties);
    }
  }]);

  return LjhAnalytics;
}();

export { LjhAnalytics as default };